module.exports = __webpack_public_path__ + "static/media/colicoli15.ec34f243.webp";